import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Container, Form, InputGroup, Button, Tab, Nav, Image, Badge } from 'react-bootstrap';
import ItemsCarousel from './common/ItemsCarousel';
// import GalleryCarousel from './common/GalleryCarousel';
import CheckoutItem from './common/CheckoutItem';
import BestSeller from './common/BestSeller';
import QuickBite from './common/QuickBite';
import StarRating from './common/StarRating';
import RatingBar from './common/RatingBar';
import Review from './common/Review';
import Icofont from 'react-icofont';
import CheckoutOrder from "./CheckOutOrder.js";
import { isOpened, getTodayDates, liefershops, loadSignedSession, saveSignedSession } from '../utils.js';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min.js';
import { Index } from "./Index.js";
import { Helmet } from "react-helmet";

const users = [
  {
    name: 'Osahan Singh',
    image: '/img/user/5.png',
    url: '#'
  },
  {
    name: 'Gurdeep Osahan',
    image: '/img/user/2.png',
    url: '#'
  },
  {
    name: 'Askbootstrap',
    image: '/img/user/3.png',
    url: '#'
  },
  {
    name: 'Osahan Singh',
    image: '/img/user/4.png',
    url: '#'
  }
]

const stateOpenClose = {
  true: "OPEN",
  false: "CLOSED"
}

const stateOpenCloseBadge = {
  true: "success",
  false: "danger"
}

class Detail extends React.Component {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(this.props.location.search);
    const queryId = params.get("id");
    const routeSlug = this.props.match?.params?.slug;
    const routePlz = this.props.match?.params?.plz;

    this.state = {
      id: queryId,
      slug: routeSlug || null,
      plz: routePlz || null,
      info: {},
      restaurantState: false,
      timeOpen: {},
      mind: 0.00,
      lieferkosten: 0.00,
      dataReceived: true,
      noDeliveryRedirect: null,
      itemsCarousel: React.createRef(),
    };

    this.checkOutItemRef = React.createRef();
  }

  async componentDidMount() {
    // Always start at the top when a partner page opens. Browsers (and some
    // routing flows) occasionally restore the scroll position of the previous
    // page, which on a long menu lands the customer at the bottom.
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }

    // Resolve which endpoint to hit. New URLs use slug; legacy ?id=N still works.
    const { id, slug } = this.state;
    let url = null;
    if (slug) url = liefershops(`api/v1/partner/by-slug/${slug}/`);
    else if (id) url = liefershops(`api/v1/partner/${id}/`);
    if (!url) return;

    // Fall back to the signed session (set previously by the homepage PLZ
    // input) for the active PLZ if it isn't in the URL.
    let plz = this.state.plz;
    if (!plz) {
      const session = await loadSignedSession();
      if (session?.plz) plz = session.plz;
    }
    if (!plz) {
      // Legacy fallback for users who still have it stored in localStorage.
      plz = localStorage.getItem("plz");
    }

    let newState = this.state;

    fetch(url, { credentials: 'include' })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.json();
      })
      .then(async (data) => {
        newState.info = data;
        newState.info.id = data.id;
        newState.restaurantState = isOpened(data);

        // Enforce delivery zone server-side via signed session; if the PLZ
        // is set and the restaurant doesn't deliver, send the customer to
        // the friendly /no-delivery page.
        if (plz) {
          const session = await saveSignedSession({
            plz,
            partner_slug: data.slug || null,
            partner_id: data.id,
          });
          if (session && session.delivers === false) {
            newState.noDeliveryRedirect = `/no-delivery/${data.slug || slug || 'restaurant'}/${plz}`;
            this.setState(newState);
            return;
          }
        }

        if (newState.restaurantState) {
          this.checkOutItemRef.current?.openRestaurant();
        }

        newState.timeOpen = getTodayDates(data);
        const products = data["produkts"] || [];

        let itemsRef = React.createRef();

        newState.categories = (
          <ItemsCarousel
            products={products}
            onCategoryAdd={() => { }}
            checkOutItem={this.checkOutItemRef}
            ref={itemsRef}
            restaurantInfo={newState.info}
          />
        );

        newState.itemsCarousel = itemsRef;

        localStorage.setItem("last-restaurant", JSON.stringify(newState.info));

        const matchedZip = (data.zip_codes || []).find(item => item.postleitzahl === plz);
        const mind = matchedZip ? matchedZip.mindestbestellwert : data.mindestbestellwert || 0;
        const lieferkosten = matchedZip ? matchedZip.lieferkosten : data.lieferkosten || 0;

        newState.mind = mind;
        newState.lieferkosten = lieferkosten;


        this.setState(newState);
      })
      .catch((error) => {
        let state = this.state;
        state.dataReceived = false;
        this.setState(state);
      });
  }

  getValue(value) {

  }

  render() {
    if (this.state.noDeliveryRedirect) {
      return <Redirect to={this.state.noDeliveryRedirect} />
    }
    if (!this.state.dataReceived) {
      return <Redirect to={Index} />
    }

    return (
      <>
        <Helmet>
          <title>{`Bestellen Sie leckeres Essen online aus ${this.state.info.name} - mit Liefershops.de`}</title>
          <meta name="description" content={`Bestellen Sie mit Liefershops.de köstliche Gerichte von ${this.state.info.name}. Genießen Sie eine schnelle Lieferung und leckere Auswahl an Speisen in Berlin`} />
          <meta name="keywords" content={`${this.state.info.name}, Restaurant, Online-Bestellung in Berlin, Essen, Lieferung`} />
          <meta property="og:title" content={`Bestellen Sie mit Liefershops.de leckeres Essen online von ${this.state.info.name} in Berlin`} />
          <meta property="og:description" content={`Entdecken Sie leckere Gerichte mit Liefershops.de von ${this.state.info.name} und bestellen schnell und einfach`} />
          <meta property="og:type" content="website" />
          <meta name="robots" content="index, follow" />

        </Helmet>
        <section className="restaurant-detailed-banner">
          <div className="text-center">
            <Image fluid className="cover center" src={this.state.info.background} alt={`Liefershops Partner Restaurant ${this.state.info.name}`} />
          </div>
          <div className="restaurant-detailed-header">
            <Container>
              <Row className="d-flex align-items-end">
                <Col md={8}>
                  <div className="restaurant-detailed-header-left">
                    <Image fluid className="mr-3 float-left imgcontain" alt={`Partner Logo ${this.state.info.name}`} src={this.state.info.logo} />
                    <h2 className="text-white">{this.state.info.name}</h2>
                    <p className="text-white mb-1"><Icofont icon="location-pin" />{this.state.info.strasse} {this.state.info.hausnummer}, {this.state.info.plz} {this.state.info.ort} <Badge variant={stateOpenCloseBadge[this.state.restaurantState]}>{stateOpenClose[this.state.restaurantState]}</Badge>
                    </p>

                    {/*   <p className="text-white mb-0"><Icofont icon="food-cart" /> Italienische, Mexicanische, Chinesische, Grill
                  </p>*/}
                    {/*<p className="text-white mb-0"><Icofont icon="food-cart" /> Mindestbestellwert: {Math.abs(this.state.lieferkosten)} €*/}
                    {/*</p>*/}
                  </div>
                </Col>
                {/* <Col md={4}>
                <div className="restaurant-detailed-header-right text-right">
                <Button variant='success' type="button"><Icofont icon="clock-time" /> 25–35 min
                </Button>
                <h6 className="text-white mb-0 restaurant-detailed-ratings">
                  <span className="generator-bg rounded text-white">
                    <Icofont icon="star" /> 3.1
                  </span> 23 Ratings  
                  <Icofont icon="speech-comments" className="ml-3" /> 91 reviews
                </h6>
                </div>
              </Col> */}
              </Row>
            </Container>
          </div>
        </section>

        <Tab.Container defaultActiveKey="first">
          <section className="offer-dedicated-nav bg-white border-top-0 shadow-sm">
            <Container>
              <Row>
                <Col md={12}>
                  {/* <span className="restaurant-detailed-action-btn float-right"> */}
                  {/* <Button variant='light' className="border-light-btn mr-1" type="button"><Icofont icon="heart" className='text-danger'/> Mark as Favourite</Button> */}
                  {/* <Button variant='light' size='sm' className="border-light-btn mr-1" type="button"><Icofont icon="cauli-flower" className='text-success' />  Pure Veg</Button>
                  <Button variant='outline-danger' size='sm' type="button"><Icofont icon="sale-discount" />  OFFERS</Button> */}
                  {/* </span> */}
                  <Nav id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Online Bestellung</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Restaurant Info</Nav.Link>
                    </Nav.Item>
                    {/* <Nav.Item>
                  <Nav.Link eventKey="second">Gallery</Nav.Link>
                  </Nav.Item> */}

                    {/* <Nav.Item>
                  <Nav.Link eventKey="fourth">Book A Table</Nav.Link>
                  </Nav.Item> */}
                    {/*  <Nav.Item>
                  <Nav.Link eventKey="fifth">Ratings & Reviews</Nav.Link>
                  </Nav.Item> */}
                  </Nav>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="offer-dedicated-body pt-2 pb-2 mt-4 mb-4">
            <Container>
              <Row>
                <Col mdlg={12} xl={8} lg={8}>
                  {/* <Col md={8}> */}
                  <div className="offer-dedicated-body-left">
                    <Tab.Content className='h-100'>
                      <Tab.Pane eventKey="first">
                        {/* <h5 className="mb-4">Recommended</h5>
                      <Form className="explore-outlets-search mb-4">
                        <InputGroup>
                        <Form.Control type="text" placeholder="Search for dishes..." />
                        <InputGroup.Append>
                          <Button type="button" variant="link">
                          <Icofont icon="search" />
                          </Button>
                        </InputGroup.Append>
                        </InputGroup>
                      </Form> */}
                        <h5 className="mb-3">Kategorien{/*  <Badge variant="success">  <Icofont icon="tags" /> 15% Off All Items </Badge>*/}</h5>
                        {this.state.categories}
                        {/* <Row>
                        <h5 className="mb-4 mt-3 col-md-12">Best Sellers</h5>
                        <Col md={4} sm={6} className="mb-4">
                          <BestSeller 
                            id={1}
                            title='World Famous'
                            subTitle='North Indian • American • Pure veg'
                            imageAlt='Product'
                            image='img/list/1.png'
                            imageClass='w-100 item-img'   //war img-fluid  class
                            price={250}
                            priceUnit='$'
                            isNew={true}
                            showPromoted={false}
                            promotedVariant='dark'
                            favIcoIconColor='text-danger'
                            getValue={this.getValue}
                          />
                        </Col>
    
                        <Col md={4} sm={6} className="mb-4">
                          <BestSeller 
                            id={2}
                            title='The osahan Restaurant'
                            subTitle='North Indian • American • Pure veg'
                            imageAlt='Product'
                            image='img/list/6.png'
                            imageClass='w-100 item-img'   //war img-fluid  class
                            price={250}
                            priceUnit='$'
                            qty={1}
                            showPromoted={false}
                            promotedVariant='dark'
                            favIcoIconColor='text-danger'
                            getValue={this.getValue}
                          />
                        </Col>
    
                        <Col md={4} sm={6} className="mb-4">
                          <BestSeller 
                            id={3}
                            title='Bite Me Sandwiches'
                            subTitle='North Indian • American • Pure veg'
                            imageAlt='Product'
                            image='img/list/3.png'
                            imageClass='w-100 item-img'   //war img-fluid  class
                            price={250}
                            priceUnit='$'
                            showPromoted={false}
                            promotedVariant='dark'
                            favIcoIconColor='text-danger'
                            getValue={this.getValue}
                          />
                        </Col>
                      </Row> */}
                        {/* <Row>
                        <h5 className="mb-4 mt-3 col-md-12">Quick Bites <small className="h6 text-black-50">3 ITEMS</small></h5>
                        <Col md={12}>
                          <div className="bg-white rounded border shadow-sm mb-4">
                          <QuickBite 
                            id={1}
                            title='Chicken Tikka Sub'
                            price={250}
                            priceUnit='$'
                            getValue={this.getValue}
                          />
                          <QuickBite 
                            id={2}
                            title='Cheese corn Roll'
                            price={600}
                            showBadge={true}
                            badgeText='BEST SELLER'
                            qty={1}
                            priceUnit='$'
                            getValue={this.getValue}
                          />
                          <QuickBite 
                            id={3}
                            title='Chicken Tikka Sub'
                            price={250}
                            showBadge={true}
                            badgeText='Pure Veg'
                            badgeVariant="success"
                            qty={2}
                            priceUnit='$'
                            getValue={this.getValue}
                          />
                          </div>
                        </Col>
                      </Row>  */}
                        {/* <Row>
                        <h5 className="mb-4 mt-3 col-md-12">Starters <small className="h6 text-black-50">3 ITEMS</small></h5>
                        <Col md={12}>
                          <div className="bg-white rounded border shadow-sm mb-4">
                          <QuickBite 
                            id={1}
                            itemClass="menu-list"
                            image="/img/5.jpg"
                            title='Chicken Tikka Sub'
                            price={250}
                            priceUnit='$'
                            getValue={this.getValue}
                          />
                          <QuickBite 
                            id={2}
                            itemClass="menu-list"
                            title='Cheese corn Roll'
                            image="/img/2.jpg"
                            price={600}
                            showBadge={true}
                            badgeText='BEST SELLER'
                            qty={1}
                            priceUnit='$'
                            getValue={this.getValue}
                          />
                          <QuickBite 
                            id={3}
                            itemClass="menu-list"
                            image="/img/3.jpg"
                            title='Chicken Tikka Sub'
                            price={250}
                            showBadge={true}
                            badgeText='Pure Veg'
                            badgeVariant="success"
                            priceUnit='$'
                            getValue={this.getValue}
                          />
                          </div>
                        </Col>
                      </Row> */}
                        {/* <Row>
                        <h5 className="mb-4 mt-3 col-md-12">Soups <small className="h6 text-black-50">8 ITEMS</small></h5>
                        <Col md={12}>
                          <div className="bg-white rounded border shadow-sm">
                          <QuickBite 
                            id={1}
                            title='Chicken Tikka Sub'
                            price={250}
                            priceUnit='€'
                            getValue={this.getValue}
                          />
                          <QuickBite 
                            id={2}
                            title='Cheese corn Roll'
                            price={600}
                            showBadge={true}
                            badgeText='BEST SELLER'
                            qty={1}
                            priceUnit='€'
                            getValue={this.getValue}
                          />
                          <QuickBite 
                            id={3}
                            title='Chicken Tikka Sub'
                            price={250}
                            showBadge={true}
                            badgeText='Pure Veg'
                            badgeVariant="success"
                            priceUnit='€'
                            getValue={this.getValue}
                          />
                          <QuickBite 
                            id={1}
                            title='Chicken Tikka Sub'
                            price={250}
                            priceUnit='€'
                            getValue={this.getValue}
                          />
                          <QuickBite 
                            id={2}
                            title='Cheese corn Roll'
                            price={600}
                            showBadge={true}
                            priceUnit='€'
                            getValue={this.getValue}
                          />
                          <QuickBite 
                            id={3}
                            title='Chicken Tikka Sub'
                            price={250}
                            showBadge={true}
                            badgeVariant="success"
                            priceUnit='€'
                            getValue={this.getValue}
                          />
                          </div>
                        </Col>
                      </Row> */}
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <div className='position-relative'>

                          {/*<GalleryCarousel />*/}
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <div id="restaurant-info" className="bg-white rounded shadow-sm p-4 mb-4">
                          {/* <div className="address-map float-right ml-5">
                          <div className="mapouter">
                          <div className="gmap_canvas">
                          <iframe title='addressMap' width="300" height="170" id="gmap_canvas" src="https://maps.google.com/maps?q=university%20of%20san%20francisco&t=&z=9&ie=UTF8&iwloc=&output=embed" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe></div>
                          </div>
                        </div> */}
                          <h5 className="mb-4">Impressum</h5>
                          <p className="mb-3"><Icofont icon="teacher" className="text-primary mr-2" />Eigentümer: {this.state.info.eigentuemer}</p>
                          <p className="mb-3"><Icofont icon="location-pin" className="text-primary mr-2" />{this.state.info.strasse} {this.state.info.hausnummer}, {this.state.info.plz} {this.state.info.ort}</p>
                          <p className="mb-2 text-black"><Icofont icon="phone-circle text-primary mr-2" />{this.state.info.telefon}</p>
                          <p className="mb-2 text-black"><Icofont icon="email text-primary mr-2" />{this.state.info.email}</p>
                          <p className="mb-2 text-black"><Icofont icon="clock-time text-primary mr-2" />Heute:  {this.state.timeOpen.open} - {this.state.timeOpen.close}
                            <Badge variant={stateOpenCloseBadge[this.state.restaurantState]} className='ml-1'>{stateOpenClose[this.state.restaurantState]}</Badge>
                            {/* <Badge variant="danger" className='ml-1'> OPEN NOW </Badge> */}
                          </p>
                          <hr className="clearfix" />
                          {/* <p className="text-black mb-0">You can also check the 3D view by using our menue map clicking here &nbsp;&nbsp;&nbsp; <Link className="text-info font-weight-bold" to="#">Venue Map</Link></p>
                        <hr className="clearfix" /> */}
                          {/* <h5 className="mt-4 mb-4">More Info</h5>
                        <p className="mb-3">Dal Makhani, Panneer Butter Masala, Kadhai Paneer, Raita, Veg Thali, Laccha Paratha, Butter Naan</p>
                        <div className="border-btn-main mb-4">
                          <Link className="border-btn text-success mr-2" to="#"><Icofont icon="check-circled" /> Breakfast</Link>
                          <Link className="border-btn text-danger mr-2" to="#"><Icofont icon="close-circled" /> No Alcohol Available</Link>
                          <Link className="border-btn text-success mr-2" to="#"><Icofont icon="check-circled" /> Vegetarian Only</Link>
                          <Link className="border-btn text-success mr-2" to="#"><Icofont icon="check-circled" /> Indoor Seating</Link>
                          <Link className="border-btn text-success mr-2" to="#"><Icofont icon="check-circled" /> Breakfast</Link>
                          <Link className="border-btn text-danger mr-2" to="#"><Icofont icon="close-circled" /> No Alcohol Available</Link>
                          <Link className="border-btn text-success mr-2" to="#"><Icofont icon="check-circled" /> Vegetarian Only</Link>
                        </div> */}
                        </div>
                      </Tab.Pane>
                      {/*   <Tab.Pane eventKey="fourth">
                      <div id="book-a-table" className="bg-white rounded shadow-sm p-4 mb-5 rating-review-select-page">
                        <h5 className="mb-4">Book A Table</h5>
                        <Form>
                          <Row>
                          <Col sm={6}>
                            <Form.Group>
                              <Form.Label>Full Name</Form.Label>
                              <Form.Control type="text" placeholder="Enter Full Name" /> 
                            </Form.Group>
                          </Col>
                          <Col sm={6}>
                            <Form.Group>
                              <Form.Label>Email Address</Form.Label>
                              <Form.Control type="text" placeholder="Enter Email address" />
                            </Form.Group>
                          </Col>
                          </Row>
                          <Row>
                          <Col sm={6}>
                            <Form.Group>
                              <Form.Label>Mobile number</Form.Label>
                              <Form.Control type="text" placeholder="Enter Mobile number" />
                            </Form.Group>
                          </Col>
                          <Col sm={6}>
                            <Form.Group>
                              <Form.Label>Date And Time</Form.Label>
                              <Form.Control type="text" placeholder="Enter Date And Time" />
                            </Form.Group>
                          </Col>
                          </Row>
                          <Form.Group className="text-right">
                          <Button variant="primary" type="button"> Submit </Button>
                          </Form.Group>
                        </Form>
                      </div>
                    </Tab.Pane> */}
                      <Tab.Pane eventKey="fifth">
                        <div id="ratings-and-reviews" className="bg-white rounded shadow-sm p-4 mb-4 clearfix restaurant-detailed-star-rating">
                          <div className="star-rating float-right">
                            <StarRating fontSize={26} star={5} getValue={this.getValue} />
                          </div>
                          <h5 className="mb-0 pt-1">Rate this Place</h5>
                        </div>
                        <div className="bg-white rounded shadow-sm p-4 mb-4 clearfix graph-star-rating">
                          <h5 className="mb-0 mb-4">Ratings and Reviews</h5>
                          <div className="graph-star-rating-header">
                            <div className="star-rating">
                              <StarRating fontSize={18} disabled={true} star={5} getValue={this.getValue} />
                              <b className="text-black ml-2">334</b>
                            </div>
                            <p className="text-black mb-4 mt-2">Rated 3.5 out of 5</p>
                          </div>
                          <div className="graph-star-rating-body">
                            <RatingBar leftText="5 Star" barValue={56} />
                            <RatingBar leftText="4 Star" barValue={23} />
                            <RatingBar leftText="3 Star" barValue={11} />
                            <RatingBar leftText="2 Star" barValue={6} />
                            <RatingBar leftText="1 Star" barValue={4} />
                          </div>
                          <div className="graph-star-rating-footer text-center mt-3 mb-3">
                            <Button type="button" variant="outline-primary" size="sm">Rate and Review</Button>
                          </div>
                        </div>
                        <div className="bg-white rounded shadow-sm p-4 mb-4 restaurant-detailed-ratings-and-reviews">
                          <Link to="#" className="btn btn-outline-primary btn-sm float-right">Top Rated</Link>
                          <h5 className="mb-1">All Ratings and Reviews</h5>
                          <Review
                            image="/img/user/1.png"
                            ImageAlt=""
                            ratingStars={5}
                            Name='Singh Osahan'
                            profileLink="#"
                            reviewDate="Tue, 20 Mar 2020"
                            reviewText="Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classNameical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classNameical literature, discovered the undoubtable source. Lorem Ipsum comes from sections"
                            likes="856M"
                            dislikes="158K"
                            otherUsers={users}
                          />
                          <hr />
                          <Review
                            image="/img/user/6.png"
                            ImageAlt=""
                            ratingStars={5}
                            Name='Gurdeep Osahan'
                            profileLink="#"
                            reviewDate="Tue, 20 Mar 2020"
                            reviewText="It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English."
                            likes="88K"
                            dislikes="1K"
                            otherUsers={users}
                          />
                          <hr />
                          <Link className="text-center w-100 d-block mt-4 font-weight-bold" to="#">See All Reviews</Link>
                        </div>
                        <div className="bg-white rounded shadow-sm p-4 mb-5 rating-review-select-page">
                          <h5 className="mb-4">Leave Comment</h5>
                          <p className="mb-2">Rate the Place</p>
                          <div className="mb-4">
                            <div className="star-rating">
                              <StarRating fontSize={26} star={5} getValue={this.getValue} />
                            </div>
                          </div>
                          <Form>
                            <Form.Group>
                              <Form.Label>Your Comment</Form.Label>
                              <Form.Control as="textarea" />
                            </Form.Group>
                            <Form.Group>
                              <Button variant="primary" size="sm" type="button"> Submit Comment </Button>
                            </Form.Group>
                          </Form>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </div>
                </Col>
                <Col mdlg={12} xl={4} lg={4}>
                  {/* <Col md={4} > */}
                  {!((this.state.info.rabatt === 0 || !this.state.info.rabatt) && parseFloat(this.state.info.rabatt_fest) === 0) ?
                    <div className="bg-white rounded shadow-sm text-white mb-4 p-3 clearfix restaurant-detailed-earn-pts card-icon-overlap">
                      <Image fluid className="float-left mr-3" src="/img/earn-score-icon.png" />
                      {this.state.info.rabatt === 0 || !this.state.info.rabatt ? "" :
                        (
                          <div>
                            <h6 className="pt-0 text-primary mb-1 font-weight-bold">Rabatt</h6>
                            <p className="mb-0">Rabatt : <span className="font-weight-bold">{Math.abs(this.state.info.rabatt)} %</span></p>
                          </div>
                        )
                      }
                      {parseInt(this.state.rabatt_fest) === 0 || !this.state.info.rabatt_fest ? "" :
                        (
                          <div>
                            <p className="mb-0">Rabatt ab {Math.abs(this.state.info.rabatt_fest_ab)} € :<span className="font-weight-bold"> {Math.abs(this.state.info.rabatt_fest)} %</span></p>
                          </div>
                        )
                      }
                      {/* { parseInt(this.state.rabatt_fest) == 0 ? "" : 
                      <p className="mb-0">Rabatt ab {this.state.info.rabatt_fest_ab} € :<span className="font-weight-bold"> {this.state.info.rabatt_fest} %</span></p>
                    } */}

                      <div className="icon-overlap">
                        <Icofont icon="sale-discount" />
                      </div>
                    </div>
                    : ""}

                  {
                    <CheckoutOrder
                      ref={this.checkOutItemRef}
                      rabbat={parseFloat(this.state.info.rabatt) || 0}
                      rabattFestAb={parseFloat(this.state.info.rabatt_fest_ab) || 0}
                      rabattFest={parseFloat(this.state.info.rabatt_fest) || 0}
                      mindestbestellwert={parseFloat(this.state.mind) || 0}
                      lieferkosten={parseFloat(this.state.lieferkosten) || 0}
                      itemsCarousel={this.state.itemsCarousel}
                      restaurantInfo={this.state.info}
                    />
                  }
                </Col>
              </Row>
            </Container>
          </section>

        </Tab.Container>
      </>
    );
  }
}



export default Detail;